import { render, staticRenderFns } from "./MonitoramentoSocioambiental.vue?vue&type=template&id=c01992ea&scoped=true&lang=pug"
import script from "./MonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./MonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoSocioambiental.vue?vue&type=style&index=0&id=c01992ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01992ea",
  null
  
)

export default component.exports